export default {
  default: 'YYYY-MM-DD',
  shortDateDisplay: 'ddd, MMM, D',
  shortDateDisplayAlt: 'ddd, MMM D',
  shortDateDisplayFrench: 'ddd D MMM',
  fullYearMonthShortDisplay: 'YYYY MMMM D',
  timeOnly: 'HH:mm',
  longDisplay: 'dddd, MMMM Do, YYYY',
  longDisplayFrench: 'dddd D MMMM YYYY',
  summaryTableLongDisplay: 'dddd, MMMM DD, YYYY',
  summaryTableLongDisplayFrench: 'dddd DD MMMM  YYYY',
  mobileLongDisplay: 'ddd, MMM Do, YYYY',
  mobileLongDisplayFrench: 'ddd MMM Do YYYY',
  customDateSelectLong: 'MMMM Do, YYYY',
  customDateSelectLongFrench: 'Do MMMM YYYY',
  routesDateSelectLong: 'MMMM D, YYYY',
  routesDateSelectLongFrench: 'D MMMM YYYY'
}
